<template>
  <div>
    <div>
      <h5 class="text-body">Break History</h5>
    </div>
    <b-table
      :items="items"
      :fields="fields"
      responsive
      show-empty
      thead-class="text-nowrap"
      :busy="loadingBreakHistories"
    >
      <template #cell(type)="{ item }">
        <span class="text-nowrap">{{
          `${item.type === "short" ? "Short" : "Long"} Term Break`
        }}</span>
      </template>
      <template #cell(appliedOn)="{ item }">
        <span class="text-nowrap">{{
          format(new Date(item.appliedAt), "yyyy-MM-dd hh:mm:ss") || "-"
        }}</span>
      </template>
      <template #cell(expires)="{ item }">
        <span class="text-nowrap">{{
          format(new Date(item.expiredAt), "yyyy-MM-dd hh:mm:ss") || "-"
        }}</span>
      </template>
      <template #cell(status)="{ item }">
        <b-badge
          :variant="formatStatus(item) === 'Active' ? 'primary' : 'success'"
          class="text-nowrap"
          >{{ formatStatus(item) }}
        </b-badge>
      </template>
    </b-table>
    <div
      v-if="paginationBreakHistories.total > 0"
      class="d-flex align-items-center justify-content-between mt-1"
    >
      <div class="text-muted small">{{ paginationSummary }}</div>
      <div
        class="d-flex align-items-center justify-content-center justify-content-sm-end"
      >
        <b-pagination
          v-model="page"
          :total-rows="paginationBreakHistories.total"
          :per-page="paginationBreakHistories.limit"
          first-number
          last-number
          class="mb-0 mt-1 mt-sm-0"
          prev-class="prev-item"
          next-class="next-item"
        >
          <template #first-text
            ><span class="text-success">First</span></template
          >
          <template #prev-text>
            <feather-icon icon="ChevronLeftIcon" size="18" />
          </template>
          <template #next-text>
            <feather-icon icon="ChevronRightIcon" size="18" />
          </template>
          <template #last-text><span class="text-info">Last</span></template>
        </b-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { BTable, BPagination, BBadge } from "bootstrap-vue";
import { format, isBefore } from "date-fns";
import { mapActions, mapState } from "vuex";

export default {
  components: {
    BTable,
    BPagination,
    BBadge,
  },
  data() {
    return {
      page: 1,
      fields: [
        { key: "type", label: "Type" },
        { key: "appliedOn", label: "Applied On" },
        { key: "expires", label: "Expires" },
        { key: "status", label: "Status" },
      ],
      items: [],
    };
  },
  watch: {
    page() {
      this.fetchBreaksHistories();
    },
  },
  computed: {
    ...mapState("user/detail", [
      "loadingBreakHistories",
      "paginationBreakHistories",
    ]),
    paginationSummary() {
      const p = this.paginationBreakHistories || {};
      const page = Number(p.page) || 1;
      const limit = Number(p.limit || p.perPage) || 10;
      const total = Number(p.total) || 0;

      const from = total === 0 ? 0 : (page - 1) * limit + 1;
      const to = total === 0 ? 0 : Math.min(page * limit, total);

      return total === 0
        ? `Showing 0 of 0 items`
        : `Showing ${from} - ${to} of ${total} items`;
    },
  },
  created() {
    this.fetchBreaksHistories();
  },
  methods: {
    ...mapActions("user/detail", ["getBreakHistoryByUser"]),
    format,
    async fetchBreaksHistories() {
      const params = {
        userId: this.$route.params.id,
        page: this.page,
      };
      const result = await this.getBreakHistoryByUser(params);
      if (result) this.items = result || [];
    },
    formatStatus(item) {
      if (!item.appliedAt || !item.expiredAt) return "-";
      return isBefore(new Date(item.expiredAt), new Date())
        ? "Expired"
        : "Active";
    },
  },
};
</script>
